export default "__VITE_ASSET__FpSpoO6h__"